// PEOPLE-ALIGN 2026-07-03 (Part 3): extracted from the Inbox breadcrumb markup added in
// INBOX-REBUILD Part 1 (`Inbox › TeeUps`) so People can render the identical structural/
// typographic treatment (`People › @handle`) via literal component reuse, not a look-alike.
// Structured for future siblings the same way the Inbox one was: a `root` crumb (grey, static)
// and a `current` crumb (dark, the active leaf). `current` is a plain string today -- for People
// this always resolves to "@<handle>" (personal scope). A future org-scope variant ("People ›
// CooWe") is NOT built here (out of scope for this pass); callers simply pass a different
// `current` string when that scope selector exists, so nothing here blocks it.
interface BreadcrumbProps {
  root: string
  current: string
  testId: string
}

const Breadcrumb = ({ root, current, testId }: BreadcrumbProps) => (
  <div
    data-testid={testId}
    className="flex items-center gap-1.5 px-6 pt-5 text-[13px] font-medium text-[#9A9CA3]">
    <span>{root}</span>
    <span aria-hidden="true">›</span>
    <span className="text-[#16181D]">{current}</span>
  </div>
)

export default Breadcrumb
